import { Injectable } from '@angular/core';

/**
 * Native port of the v1 `notifications` service (account-v1/src/components/
 * common/notifications/notifications.js) — "in-app notifications" that are, in
 * their entirety, `$window.alert(message)`. WS5 #10 Stage A inc 2w: replaces the
 * `$injector.get('notifications')` grab in ft-touchpoint-messaging (the
 * sample-email-sent success/error toasts; ft-touchpoint-integration next).
 */
@Injectable({ providedIn: 'root' })
export class NotificationsService {
  show(message: string): void {
    window.alert(message);
  }
}
